module.exports = __webpack_public_path__ + "static/media/8799.604e2ec4.png";